globalThis.tickerUtils = {
    _fetchNewTickerTimestamps: async () => {
        const response = await fetch(window.location.pathname);
        if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);

        const html = await response.text();
        const dom = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(
            dom.querySelectorAll('.newsItem')
        ).map((item) => item.getAttribute('data-time'));
    },

    _getTickerTimestamps: () => {
        return Array.from(
            document.querySelectorAll('.newsItem')
        ).map((item) => item.getAttribute('data-time'));
    },

    _update: async () => {
        const newDataAlert = document.querySelector('.new-data-alert');
        if (!newDataAlert) throw new Error('New data alert not found');

        try {
            // Compare current items with fresh data
            const currentTimestamps = globalThis.tickerUtils._getTickerTimestamps();
            const fetchedTimestamps = await globalThis.tickerUtils._fetchNewTickerTimestamps();

            // Show alert if timestamps differ
            if (JSON.stringify(fetchedTimestamps) !== JSON.stringify(currentTimestamps)) {
                // @ts-ignore
                newDataAlert.style.display = 'block';
            }
        } catch (error) {
            console.error('Update check error:', error);
        }
    },

    initUpdateLoop: (/** @type {number} */ intervalSeconds) => {
        setInterval(async () => {
            globalThis.tickerUtils._update();
        }, intervalSeconds * 1000);
    },
}

/**
 * Initializes live ticker if present on page
 */
async function initLiveticker() {
    const liveTicker = document.querySelector('.live-ticker');
    if (liveTicker) {
        // Check for updates every 60 seconds
        globalThis.tickerUtils.initUpdateLoop(60);
    }
}


export { initLiveticker };
